/**
 *  å­æ¾åç«¯èªå®ä¹å¸¸é
 */

export enum Platform {
    pc = 1,

    iOS = 2,

    android = 3
}

export enum Applications {
    message = 0,

    drive = 1,

    task = 2,

    calendar = 3,

    report = 4,

    crm = 5,

    approval = 6,

    leave = 9,

    bulletin = 20,

    appraisal = 30,

    okr = 40,

    portal = 50,

    mission = 60
}

export const COLOR_NAMES = [
    { name: '1', color: '#a7cfae', n_color: '#22d7bb' },
    { name: '2', color: '#9ceceb', n_color: '#18bfa4' },
    { name: '3', color: '#a1e1e6', n_color: '#2cccda' },
    { name: '4', color: '#92d8d8', n_color: '#2dbcff' },
    { name: '5', color: '#90cccc', n_color: '#4e8af9' },
    { name: '6', color: '#a5d8f5', n_color: '#7076fa' },
    { name: '7', color: '#bed3f6', n_color: '#9473fd' },
    { name: '8', color: '#a0c6e5', n_color: '#c472ee' },
    { name: '9', color: '#75aad2', n_color: '#ef7ede' },
    { name: '10', color: '#fec2c1', n_color: '#f969aa' },
    { name: '11', color: '#fedebb', n_color: '#fc587b' },
    { name: '12', color: '#f5e9aa', n_color: '#fa5a55' },
    { name: '13', color: '#ebb892', n_color: '#ff7747' },
    { name: '14', color: '#eda395', n_color: '#ffa415' },
    { name: '15', color: '#dfb3a5', n_color: '#ffd234' },
    { name: '16', color: '#f5aac8', n_color: '#99d75a' },
    { name: '17', color: '#c495af', n_color: '#66c060' },
    { name: '18', color: '#cebdf3', n_color: '#39ba5d' }
];

export const CHECK_POINTS = [
    'admin_signup_mode', // åå°ç®¡çå å¥ä¼ä¸çæ¨¡å¼
    'admin_member_operation', // æåæä½ç®¡ç, å¢æ¹å 
    'admin_department_operation', // é¨é¨æä½ç®¡ç, å¢æ¹å 
    'admin_manage_service', // æå¡éæ
    'admin_manage_data', // æ°æ®ç®¡ç
    'admin_manage_billing', // è´¦åç®¡ç
    'admin_security_authentication', // å®å¨ç®¡ç - è®¤è¯
    'admin_invite_member', // éè¿é®ç®±éè¯·æå
    'admin_transfer_team', // è½¬è®©ä¼ä¸
    'admin_change_domain', // ä¿®æ¹ domain åå
    'admin_delete_team', // è§£æ£ä¼ä¸
    'admin_account_setting', // å¸æ·è®¾ç½®
    'allow_use_password', // å¯ç ç»å½
    'send_code_by_mobile', // ä½¿ç¨ææºå·åééªè¯ç ï¼ç¨äº ææºå·å¿è®°å¯ç ï¼éæ°è®¾ç½®ææºå·
    'send_code_by_email', // ä½¿ç¨é®ç®±åééªè¯ç ï¼ç¨äºå¿è®°å¯ç ï¼éæ°è®¾ç½®é®ç®±
    'expired_notification', // è¿æç»­è´¹æé
    'upgrade_notification', // åçº§æç¤º, çæ¬åçº§æç¤º
    'suggest_feedback', // å»ºè®®åé¦
    'notification_sms', // ç­ä¿¡æé
    'notification_email', // é®ä»¶æé
    'office_preview', // office é¢è§æå¡
    'inside_link', // åé¨ç«ç¹é¾æ¥
    'admin_data_stats', // åå°æ°æ®ç»è®¡
    'switch_other_team' // åæ¢ä¼ä¸
];
